import { j as e } from "../../../jsx-runtime-BwWtxLpl.js";
import "react";
import o from "prop-types";
import a from "classnames";
const i = ({ children: s, className: r = "", ...t }) => {
  const m = a({
    "motif-modal-body": !0,
    [r]: !0
  });
  return /* @__PURE__ */ e.jsx("div", { ...t, className: m, "data-motif-modal-body": !0, children: s });
};
i.propTypes = {
  children: o.node,
  className: o.string
};
export {
  i as MotifModalBody
};
